import script from "./DuplicatedCampaignDialog.vue?vue&type=script&setup=true&lang=ts"
export * from "./DuplicatedCampaignDialog.vue?vue&type=script&setup=true&lang=ts"

import "./DuplicatedCampaignDialog.vue?vue&type=style&index=0&id=4313ba8a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4313ba8a"]])

export default __exports__